export default __webpack_public_path__ + "static/media/0070BLEU.92ca86dd.pdf";